import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  useTheme,
} from "@mui/material";
import { useGetProfileQuery } from "../../features/api/userApiSlice";
import * as Constant from "../../features/constant";


const WalletCard = ({ screens, token }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const apkUrl = `${window.location.origin}/${process.env.REACT_APP_APK}`;

  const openAppOrDownload = () => {
    const appLink = process.env.REACT_APP_APK_SCHEME;

    let appOpened = false;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    const iframe = document.createElement("iframe");
    iframe.src = appLink;
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    setTimeout(() => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.body.removeChild(iframe);

      if (!appOpened) {
        window.location.href = apkUrl;
      }
    }, 1500);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1,
        backgroundColor: theme.palette.walletScreen,
      }}
    >
      <Grid container pt={0} spacing={1} justifyContent="center">
        {screens?.map((screen) => (
          <Grid
            item
            xs={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              p: 0,
            }}
            onClick={() => {
              const noTokenRequired = ["referral", "app"].includes(screen?.code?.toLowerCase());

              if (!token && !noTokenRequired) {
                navigate(Constant.getPath("/login"));
                return;
              }

              switch (screen?.code?.toLowerCase()) {
                case "promotion":
                case "vip":
                  navigate(Constant.getPath("/" + screen?.code));
                  break;
                case "app":
                  openAppOrDownload();
                  break;
                case "referral":
                  if (process.env.REACT_APP_REPLACE_AFFILIATE_WITH_REFERRAL === "true") {
                    if (token) {
                      navigate(Constant.getPath("/referral"));
                    } else {
                      navigate(Constant.getPath("/login"));
                    }
                  } else {
                    // Original affiliate logic
                    const affiliateSite = process.env.REACT_APP_AFFILIATE_SITE;

                    navigate(Constant.getPath("/affiliate"), {
                      state: {
                        screen: "Affiliate",
                      }
                    });
                  }
                  break;
                default:
                  navigate(Constant.getPath("/profileWallet"), {
                    state: { screen: screen?.code },
                  });
              }
            }}
          >
            {screen?.icon}
            <Typography textAlign="center" fontSize={10} color={process.env.REACT_APP_COLOR_WALLETCARD_TEXT || "white"}>
              {screen?.label}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WalletCard;
